<template>
	<header class="premium-landing-hero bg-color-content-primary pt-300 bg-gradient-premium">
		<div
			class="container py-400 pt-600-md display-flex flex-direction-column align-items-center gap-300-md gap-400"
		>
			<div
				class="col-8-md col-2-offset-md text-align-center display-flex flex-direction-column align-items-center gap-100 text-color-white"
			>
				<h1 class="heading-xl-md heading-2">Get rewarded for growing with&nbsp;Fundrise</h1>
				<p class="body-xl-md body-lg mt-0"
					>Grow your account to $100,000 or more to unlock exclusive investments, white-glove support, and a
					12-month fee&nbsp;waiver.</p
				>
			</div>
			<div
				:class="[
					'col-6-md col-3-offset-md display-flex flex-direction-column align-items-center gap-100 text-align-center',
					{ 'flex-direction-column-reverse': thirdPartyAuthStore.isSignupEnabled }
				]"
			>
				<div class="width-100"
					><MarketingHeroCta
						:form-config="leadCaptureConfig"
						:center-button="true"
						component-id="premium-landing-hero"
						:is-dark-mode="true"
					/>
				</div>
				<p class="body-sm mt-0 text-color-white"
					>Get started in minutes and join thousands of investors with $100,000+ on&nbsp;Fundrise.</p
				>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import { LeadCaptureFormConfig } from 'types/layout/lead';
import MarketingHeroCta from '@components/marketing-site/marketing-hero-cta.vue';
import { useThirdPartyAuthStore } from '@stores/third-party-auth';

const thirdPartyAuthStore = useThirdPartyAuthStore();

const leadCaptureConfig: LeadCaptureFormConfig = {
	signupFlowType: 'STANDARD',
	feeWaiver: 'PREMIUM_AUM_THRESHOLD_CROSSED',
	centerButton: true,
	thirdPartyAuthTheme: 'SECONDARY',
	thirdPartyAuthDisclaimerClass: 'muted text-align-center'
};
</script>
